import { computed } from 'vue';

const getMapViewComputedStyles = (props, state) => {
    const mapViewClasses = computed(() => {
        const classes = ['MapView__content'];
        if (props.mapStyle === 'dark') {
            classes.push('MapView__content--dark');
        }
        else {
            classes.push('MapView__content--light');
        }
        if (props.hideControlButtons) {
            classes.push('MapView__content--no-markers');
        }
        if (props.disabled || (props.expandable && !state.isMapAlertOpened.value)) {
            classes.push('MapView__content--minimized');
        }
        return classes;
    });
    const parentMapViewClasses = computed(() => {
        const classes = [];
        if (props.expandable) {
            classes.push('MapView--expandable');
        }
        if (props.disabled) {
            classes.push('MapView--disabled');
        }
        return classes;
    });
    const parentMapViewStyles = computed(() => {
        if (props.expandable) {
            return `height: ${props.minimizedHeight}px`;
        }
        return '';
    });
    const modalControlClasses = computed(() => {
        const classes = ['MapView__modal-control'];
        if (props.mapStyle === 'dark') {
            classes.push('MapView__modal-control--dark');
        }
        else {
            classes.push('MapView__modal-control--light');
        }
        return classes;
    });
    const modalCloseButtonClasses = computed(() => {
        const classes = ['MapView__modal-control-close-button'];
        if (props.mapStyle === 'dark') {
            classes.push('MapView__modal-control-close-button--dark');
        }
        else {
            classes.push('MapView__modal-control-close-button--light');
        }
        return classes;
    });
    return {
        mapViewClasses,
        parentMapViewClasses,
        parentMapViewStyles,
        modalControlClasses,
        modalCloseButtonClasses,
    };
};

export { getMapViewComputedStyles };
